
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Форматирует дату в локализованную строку
 * @param date Строка даты или объект Date
 * @returns Отформатированная строка даты
 */
export function formatDate(date: string | Date | undefined | null): string {
  if (!date) return 'Не указана';
  
  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return dateObj.toLocaleDateString('ru-RU', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch (error) {
    console.error('Ошибка форматирования даты:', error);
    return String(date);
  }
}
